import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { ICE_DRIFT } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'

const id = 'IceDrift'

export class IceDrift extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        try {
          map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
        } catch (error) {
          console.log(error)
        }
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [ICE_DRIFT({ idToken, timeIso })],
      tileSize: 256
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={rasterSource} />
        <Layer
          type='raster'
          id={id}
          sourceId={id}
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={paint}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id),
      paint: getPaint(state, id),
      time: state.layer.times.IceDrift || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(IceDrift)



// WEBPACK FOOTER //
// ./src/layers/IceDrift.js